import { combineReducers } from "@reduxjs/toolkit";
import businessPostingGroupSlice from "./slices/businessPostingGroupSlice";
import paymentTermSlice from "./slices/paymentTermSlice";
import countrySlice from "./slices/countrySlice";
import dashboardSlice from "./slices/dashboardSlice";
import stateSlice from "./slices/stateSlice";
import citySlice from "./slices/citySlice";
import currencySlice from "./slices/currencySlice";
import vendorPostingGroupSlice from "./slices/vendorPostingGroupSlice";
import serieSlice from "./slices/serieSlice";
import serieDetailSlice from "./slices/serieDetailSlice";
import moduleSlice from "./slices/moduleSlice";
import serieSetupSlice from "./slices/serieSetupSlice";
import cashDeclarationSlice from "./slices/cashDeclarationSlice";
import configurationSlice from "./slices/configurationSlice";
import configurationComisionSlice from "./slices/configurationComisionSlice";
import infoCodeSlice from "./slices/infoCodeSlice";
import attributeSlice from "./slices/attributeSlice";
import timeMeasurementSlice from "./slices/timeMeasurementSlice";
import deparmentTypeSlice from "../HumanResources/slices/deparmentTypeSlice";
import workAreaSlice from "../HumanResources/slices/workAreaSlice";
import workPositionSlice from "../HumanResources/slices/workPositionSlice";
import workPositionTypeSlice from "../HumanResources/slices/workPositionTypeSlice";
import genderSlice from "./slices/genderSlice";
import departmentSlice from "../HumanResources/slices/departmentSlice";
import costCenterSlice from "../HumanResources/slices/costCenterSlice";
import storeSlice from "../Stores/slices/storeSlice";
import positionSlice from "../HumanResources/slices/positionSlice";
import terminationCategorySlice from "../HumanResources/slices/terminationCategorySlice";
import maritalStatusSlice from "../HumanResources/slices/maritalStatusSlice";
import monthSlice from "./slices/monthSlice";
import contributionTypeSlice from "../HumanResources/slices/contributionTypeSlice";
import contributionEmployeeSlice from "../HumanResources/slices/contributionEmployeeSlice";
import infoEmployeeSlice from "../HumanResources/slices/infoEmployeeSlice";
import documentByEmployeeSlice from "../HumanResources/slices/documentByEmployeeSlice";

export default combineReducers({
  businessPostingGroup: businessPostingGroupSlice,
  paymentTerm: paymentTermSlice,
  country: countrySlice,
  dashboard: dashboardSlice,
  state: stateSlice,
  city: citySlice,
  currency: currencySlice,
  vendorPostingGroup: vendorPostingGroupSlice,
  serie: serieSlice,
  serieDetail: serieDetailSlice,
  module: moduleSlice,
  serieSetup: serieSetupSlice,
  cashDeclaration: cashDeclarationSlice,
  configuration: configurationSlice,
  configurationComision: configurationComisionSlice,
  infoCode: infoCodeSlice,
  attribute: attributeSlice,
  timeMeasurement: timeMeasurementSlice,
  deparmentType: deparmentTypeSlice,
  workPositionType: workPositionTypeSlice,
  workArea: workAreaSlice,
  workPosition: workPositionSlice,
  gender: genderSlice,
  department: departmentSlice,
  costCenter: costCenterSlice,
  store: storeSlice,
  position: positionSlice,
  terminationCategory: terminationCategorySlice,
  maritalStatus: maritalStatusSlice,
  month: monthSlice,
  contributionType: contributionTypeSlice,
  infoEmployee: infoEmployeeSlice,
  contributionEmployee: contributionEmployeeSlice,
  documentByEmployee: documentByEmployeeSlice,
});
